import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/domains';
import { AiChangeType } from '../../../../../ai';
export var AI_ACCEPT_QUESTION_CHANGE_USE_CASE = 'AI_ACCEPT_QUESTION_CHANGE_USE_CASE';
/**
 * Orchestrator use case for accepting an AI question change.
 * - Add: saves the new question (SaveQuestionUseCase → create).
 * - Update: saves the updated question (SaveQuestionUseCase → update).
 * - Delete: deletes the question (DeleteQuestionUseCase).
 */

export var AiAcceptQuestionChangeUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(AiAcceptQuestionChangeUseCase, _UseCase);

  var _super = _createSuper(AiAcceptQuestionChangeUseCase);

  function AiAcceptQuestionChangeUseCase(saveQuestionUseCase, deleteQuestionUseCase) {
    var _this;

    _classCallCheck(this, AiAcceptQuestionChangeUseCase);

    _this = _super.call(this);
    _this.saveQuestionUseCase = saveQuestionUseCase;
    _this.deleteQuestionUseCase = deleteQuestionUseCase;
    return _this;
  }

  _createClass(AiAcceptQuestionChangeUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var changeType, question, questionId, saveResult, _saveResult, _input$questions, questions, headings, deleteResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                changeType = input.changeType, question = input.question;
                questionId = question.id.toString();
                _context.t0 = changeType;
                _context.next = _context.t0 === AiChangeType.Add ? 5 : _context.t0 === AiChangeType.Update ? 12 : _context.t0 === AiChangeType.Delete ? 19 : 27;
                break;

              case 5:
                question.markAsNew();
                _context.next = 8;
                return this.saveQuestionUseCase.execute({
                  question: question
                });

              case 8:
                saveResult = _context.sent;

                if (!saveResult.isFailure) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", mappingResultError(saveResult));

              case 11:
                return _context.abrupt("break", 28);

              case 12:
                question.activate();
                _context.next = 15;
                return this.saveQuestionUseCase.execute({
                  question: question
                });

              case 15:
                _saveResult = _context.sent;

                if (!_saveResult.isFailure) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", mappingResultError(_saveResult));

              case 18:
                return _context.abrupt("break", 28);

              case 19:
                questions = (_input$questions = input.questions) !== null && _input$questions !== void 0 ? _input$questions : [];
                headings = input.headings;
                _context.next = 23;
                return this.deleteQuestionUseCase.execute({
                  currentQuestion: question,
                  questions: questions,
                  headings: headings
                });

              case 23:
                deleteResult = _context.sent;

                if (!deleteResult.isFailure) {
                  _context.next = 26;
                  break;
                }

                return _context.abrupt("return", mappingResultError(deleteResult));

              case 26:
                return _context.abrupt("break", 28);

              case 27:
                return _context.abrupt("break", 28);

              case 28:
                return _context.abrupt("return", Result.ok({
                  questionId: questionId
                }));

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return AiAcceptQuestionChangeUseCase;
}(UseCase);